import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Resource, WeeklyCalendar } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editResourceWeeklyCalendar(
    request: Boundaries["editResourceWeeklyCalendar"]["request"],
  ): void;
}

function useEditResourceWeeklyCalendar(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditResourceWeeklyCalendarRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditResourceWeeklyCalendarRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditResourceWeeklyCalendarRequestFailure(resource),
    ),
    editResourceWeeklyCalendar: core.editResourceWeeklyCalendar,
  };
}

export { useEditResourceWeeklyCalendar };
